/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetTextMd5Request = { text: string };

export const GetTextMd5Request$zodSchema: z.ZodType<GetTextMd5Request> = z
  .object({
    text: z.string().describe("需要计算哈希值的文本"),
  });

export type GetTextMd5Details = {};

export const GetTextMd5Details$zodSchema: z.ZodType<GetTextMd5Details> = z
  .object({});

/**
 * 缺少text参数
 */
export type GetTextMd5BadRequestResponseBody = {
  code?: string | undefined;
  details?: GetTextMd5Details | undefined;
  message?: string | undefined;
};

export const GetTextMd5BadRequestResponseBody$zodSchema: z.ZodType<
  GetTextMd5BadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetTextMd5Details$zodSchema).optional(),
  message: z.string().optional(),
}).describe("缺少text参数");

/**
 * 成功响应
 */
export type GetTextMd5ResponseBody = { md5?: string | undefined };

export const GetTextMd5ResponseBody$zodSchema: z.ZodType<
  GetTextMd5ResponseBody
> = z.object({
  md5: z.string().optional(),
}).describe("成功响应");

export type GetTextMd5Response =
  | GetTextMd5ResponseBody
  | GetTextMd5BadRequestResponseBody;

export const GetTextMd5Response$zodSchema: z.ZodType<GetTextMd5Response> = z
  .union([
    z.lazy(() => GetTextMd5ResponseBody$zodSchema),
    z.lazy(() => GetTextMd5BadRequestResponseBody$zodSchema),
  ]);
